import React from "react"
import { Typography, Box } from "@material-ui/core"
import AddTagSVG from "../icons/AddTagSVG"
import MultiTag from "./MultiTag"
import { DETAIL_VIEW, LIST_VIEW } from "../../utils"
import ViewerMultiTag from "./ViewerMultiTag"

function MultiTagView(props) {
	return (
		<>
			{props?.view === LIST_VIEW && <MultiTag fileData={props?.fileData} tagState={props?.tagState} />}
			{props?.view === DETAIL_VIEW && (
				<ViewerMultiTag fileData={props?.fileData} retainedFilterJobData={props?.retainedFilterJobData} />
			)}
		</>
	)
}

export default MultiTagView
